import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import styled from 'styled-components';

import { State } from 'src/state/ducks';
import * as bakedBreadActions from 'src/state/ducks/bakedBread/actions';
import * as bakedBreadTagActions from 'src/state/ducks/bakedBreadTag/actions';
import * as shopActions from 'src/state/ducks/shop/actions';

import StyleConfig from 'src/constants/StyleConfig';
import { DefaultPageProps, HistoryProps } from 'src/constants/Interface';

import { BakedBreadEntity } from 'src/firebase/db/BakedBreads';
import { UserRole } from 'src/firebase/db/Admins';

import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import Heading from 'src/components/atoms/typo/Heading';
import BakedBreadForm from 'src/components/organisms/form/BakedBreadForm';
import SpinnerModal from 'src/components/organisms/loading/SpinnerModal';

type OwnProps = {
  id: string;
};

type Props = DefaultPageProps &
  HistoryProps &
  OwnProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const BakedBreadEditPage = (props: Props) => {
  const {
    login_shop_id,
    bakedBread,
    bakedBreadTags,
    shops,
    isFetching,
    isAdmin,
    getShops,
    updateBakedBread,
    getBakedBreads,
    getBakedBreadTags,
    errors,
  } = props;

  useEffect(() => {
    getShops();
    getBakedBreads(login_shop_id);
    getBakedBreadTags();
  }, [getShops, getBakedBreads, getBakedBreadTags, login_shop_id]);

  if (!bakedBread || !shops) {
    return null;
  }

  return (
    <DefaultLayout {...props}>
      <Container>
        <SpinnerModal isLoading={isFetching} />
        <Heading tag="h1" text="焼き上がりを通知するパンを編集" />
        <BakedBreadForm
          formType="UPDATE"
          isAdmin={isAdmin}
          bakedBread={bakedBread}
          bakedBreadTags={bakedBreadTags}
          shops={shops}
          submit={updateBakedBread}
          errors={errors}
        />
      </Container>
    </DefaultLayout>
  );
};

const Container = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M16};
`;

const mapStateToProps = (state: State, ownProps: OwnProps) => {
  const bakedBread = state.bakedBread.resource.find((bread) => bread.id === ownProps.id);
  const shopIds = state.admin.user.shop_ids;
  return {
    bakedBread,
    errors: state.bakedBread.validationErrors,
    shops: state.shop.resource.filter((shop) => shopIds.includes(shop.id)),
    bakedBreadTags: state.bakedBreadTag.resource.filter(
      ({ is_disabled, is_featured }) => !is_disabled && is_featured,
    ),
    isFetching:
      state.bakedBread.isFetching || state.shop.isFetching || state.bakedBreadTag.isFetching,
    isAdmin: state.admin.user.role === UserRole.ADMIN,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getShops: () => dispatch(shopActions.getShops()),
  getBakedBreads: (shopId: string) => dispatch(bakedBreadActions.getBakedBreads(shopId)),
  getBakedBreadTags: () => dispatch(bakedBreadTagActions.getBakedBreadTags()),
  updateBakedBread: (payload: BakedBreadEntity) =>
    dispatch(bakedBreadActions.updateBakedBread(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(BakedBreadEditPage);
